/* OkeyDice — Couche d'amélioration UX (additive, progressive enhancement). */
(function () {
  'use strict';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(pointer: fine)').matches;

  document.documentElement.classList.add('okd-page-fade');

  /* ---- Reveal au scroll ---- */
  var revealObserver = null;
  if (!REDUCED && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('okd-in');
          e.target.style.willChange = 'auto';
          revealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
  }
  function initReveal(root) {
    if (!revealObserver) return;
    root.querySelectorAll('[data-okd-reveal]:not([data-okd-rev])').forEach(function (el) {
      el.setAttribute('data-okd-rev', '');
      revealObserver.observe(el);
    });
    var main = document.getElementById('MainContent');
    if (!main) return;
    main.querySelectorAll('.shopify-section:not([data-okd-rev])').forEach(function (sec) {
      sec.setAttribute('data-okd-rev', '');
      if (sec.querySelector('[data-reveal]')) return;
      if (sec.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      sec.classList.add('okd-auto-reveal');
      revealObserver.observe(sec);
    });
  }

  /* ---- Tilt 3D ---- */
  function initTilt(root) {
    if (REDUCED || !FINE) return;
    root.querySelectorAll('.okeydice-card:not([data-okd-tilt]), [data-okd-tilt-on]:not([data-okd-tilt])').forEach(function (card) {
      card.setAttribute('data-okd-tilt', '');
      card.classList.add('okd-tilt');
      var glare = document.createElement('span');
      glare.className = 'okd-tilt__glare';
      card.appendChild(glare);
      var raf = null;
      card.addEventListener('pointermove', function (ev) {
        if (ev.pointerType && ev.pointerType !== 'mouse') return;
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width;
        var py = (ev.clientY - r.top) / r.height;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var rx = (0.5 - py) * 7;
          var ry = (px - 0.5) * 9;
          card.style.transition = 'none';
          card.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-4px)';
          card.style.setProperty('--okd-mx', (px * 100).toFixed(1) + '%');
          card.style.setProperty('--okd-my', (py * 100).toFixed(1) + '%');
        });
      });
      card.addEventListener('pointerenter', function () { card.classList.add('okd-tilt--active'); });
      card.addEventListener('pointerleave', function () {
        card.classList.remove('okd-tilt--active');
        card.style.transition = '';
        card.style.transform = '';
      });
    });
  }

  /* ---- Boutons magnétiques ---- */
  function initMagnetic(root) {
    if (REDUCED || !FINE) return;
    root.querySelectorAll('.button--primary:not([data-okd-mag]), .okeydice-btn:not([data-okd-mag])').forEach(function (btn) {
      btn.setAttribute('data-okd-mag', '');
      btn.addEventListener('pointermove', function (ev) {
        if (ev.pointerType && ev.pointerType !== 'mouse') return;
        var r = btn.getBoundingClientRect();
        var mx = (ev.clientX - r.left - r.width / 2) * 0.25;
        var my = (ev.clientY - r.top - r.height / 2) * 0.35;
        btn.style.transform = 'translate(' + mx.toFixed(1) + 'px,' + my.toFixed(1) + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---- Parallaxe (opt-in) ---- */
  var parallaxEls = [];
  function collectParallax(root) {
    if (REDUCED) return;
    root.querySelectorAll('[data-okd-parallax]:not([data-okd-px])').forEach(function (el) {
      el.setAttribute('data-okd-px', '');
      el.__okdSpeed = parseFloat(el.getAttribute('data-okd-parallax-speed')) || 0.2;
      parallaxEls.push(el);
    });
  }
  function updateParallax() {
    var vh = window.innerHeight;
    for (var i = 0; i < parallaxEls.length; i++) {
      var el = parallaxEls[i];
      var r = el.getBoundingClientRect();
      var offset = ((r.top + r.height / 2) - vh / 2) * -el.__okdSpeed;
      el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
    }
  }

  /* ---- Barre de progression ---- */
  var bar = null;
  function initProgress() {
    if (REDUCED || bar) return;
    bar = document.createElement('div');
    bar.className = 'okd-progress';
    document.body.appendChild(bar);
  }
  function updateProgress() {
    if (!bar) return;
    var hgt = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.width = (hgt > 0 ? (window.scrollY / hgt) * 100 : 0) + '%';
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { updateProgress(); updateParallax(); ticking = false; });
  }

  function initAll(root) {
    root = root || document;
    try { initReveal(root); } catch (e) {}
    try { initTilt(root); } catch (e) {}
    try { initMagnetic(root); } catch (e) {}
    try { collectParallax(root); } catch (e) {}
  }

  function boot() {
    initProgress();
    initAll(document);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    var main = document.getElementById('MainContent');
    if (main) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { initAll(document); onScroll(); }, 150);
      }).observe(main, { childList: true });
    }
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); onScroll(); });
})();
